import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-callc_parkfee",
  "use": "icon-callc_parkfee-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-callc_parkfee\"><clipPath id=\"icon-callc_parkfee_a\"><path d=\"m0 0h20v20h-20z\" /></clipPath><g clip-path=\"url(#icon-callc_parkfee_a)\" fill=\"#1a1a1a\"><path d=\"m10 19.083c-5.009 0-9.083-4.075-9.083-9.083 0-5.009 4.075-9.083 9.083-9.083s9.083 4.074 9.083 9.083c0 5.008-4.074 9.083-9.083 9.083zm0-16.667c-4.182 0-7.583 3.402-7.583 7.583s3.402 7.583 7.583 7.583 7.583-3.402 7.583-7.583-3.401-7.583-7.583-7.583z\" /><path d=\"m7 6h3.315c1.926 0 2.901.818 2.901 2.453 0 1.646-.974 2.475-2.923 2.475h-1.983v3.069h-1.31zm1.31 1.12v2.688h1.904c.582 0 1.008-.112 1.277-.314.269-.213.403-.56.403-1.042s-.146-.818-.414-1.019c-.269-.213-.694-.314-1.266-.314h-1.904z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/callc_parkfee.svg
// module id = AN/y
// module chunks = 87